// 整列スマートガイドの「整列対象（static）矩形」を収集する共有ヘルパー。
// 移動ドラッグ（use-object-drag）とリサイズ（use-resize-handle）の双方から利用し、
// 「どのオブジェクトを整列対象にするか」の判定を一元化する。

import type { ViewState } from "../../../lib/canvas-coordinates";
import type { AlignmentBox } from "../../../lib/canvas-alignment";
import { aabbIntersects, viewportInStage } from "../../../lib/culling";
import { useCanvasDocStore } from "../store/canvas-doc-store";

/**
 * 整列対象となる他オブジェクトの矩形を集める。ビューポート内のものに絞ってコストを抑える。
 * movingIds に含まれるオブジェクト（操作中の対象自身。複製ドラッグでは複製元）は常に除外する。
 * - コメントスレッド（ピン）はビューポート固定の UI 装飾で、保存 x/y/w/h は名目値のため整列対象にしない。
 * - 回転済みオブジェクトは非回転枠 x/y/w/h と見た目の端がずれるため、整列対象から除外する。
 */
export function collectAlignmentStatics(
  movingIds: ReadonlySet<string>,
  view: ViewState
): readonly AlignmentBox[] {
  const objects = useCanvasDocStore.getState().objects;
  const viewport = viewportInStage(
    view,
    typeof window === "undefined" ? 0 : window.innerWidth,
    typeof window === "undefined" ? 0 : window.innerHeight
  );
  const boxes: AlignmentBox[] = [];
  for (const obj of Object.values(objects)) {
    if (movingIds.has(obj.id)) continue;
    if (obj.type === "comment-thread") continue;
    if (obj.rotation) continue;
    const box = { x: obj.x, y: obj.y, w: obj.w, h: obj.h };
    if (!aabbIntersects(viewport, box)) continue;
    boxes.push(box);
  }
  return boxes;
}
